import { render, staticRenderFns } from "./PlansFeaturesCards.vue?vue&type=template&id=afa945fa&"
import script from "./PlansFeaturesCards.vue?vue&type=script&lang=js&"
export * from "./PlansFeaturesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports